<template>
  <div :id="getClass()" class="modal">
    <div @click="closeModal($event)" class="close-modal">
      <font-awesome-icon icon="times"></font-awesome-icon>
    </div>
    <div class="modal-w">
      <div class="modal-content">
        <h3>
          <span>n°{{number}}</span>
        </h3>
        <p v-html="text"></p>
      </div>
      <div v-if="verbatim" class="modal-footer">
        <router-link :to="`/verbatims/${id}/${i}`">
          <img src="../assets/icons/verbatim.svg" alt=""> {{$t('discoverVerbatim')}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null
    },
    step: {
      type: String,
      default: null
    },
    i: {
      type: Number,
      default: null
    },
    index: {
      type: Number,
      default: null
    },
    number: {
      type: Number,
      default: null
    },
    verbatim: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    id() {
      return 1
    }
  },
  methods: {
    closeModal(event) {
      event.currentTarget.parentNode.parentNode.classList.remove("is-active");
      event.currentTarget.parentNode.classList.remove("active");
      document.getElementById("bg").classList.remove("active");
    },
    getClass() {
      let value = this.sanitize(this.step + "-" + this.index);
      return value;
    },
    sanitize(name) {
      return name.replace(/[^a-z0-9]/g, function(s) {
        var c = s.charCodeAt(0);
        if (c == 32) return "-";
        if (c >= 65 && c <= 90) return "_" + s.toLowerCase();
        return "__" + ("000" + c.toString(16)).slice(-4);
      });
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/css/variables.scss";
.modal {
  opacity: 0;
  position: absolute;
  top: 41%;
  z-index: 33;
  width: 380px;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 10px;
  color: #fff;
  padding: 1.5em;
  z-index: 0;
  transition: opacity 0s;
  box-shadow: 1px 5px 8px rgba(0, 0, 0, 0.3);
  &.active {
    display: block;
    z-index: 9999;
    opacity: 1;
    transition: opacity 0.3s;
  }
  &.left {
    right: 80%;
    &::after {
      content: "";
      position: absolute;
      right: -13px;
      top: -1px;
      width: 0;
      height: 0;
      border-top: 0px solid transparent;
      border-bottom: 44px solid transparent;
      border-left: 44px solid #fff;
    }
  }
  &.right {
    left: 80%;
    &::after {
      content: "";
      position: absolute;
      left: -13px;
      top: -1px;
      width: 0;
      height: 0;
      border-top: 0px solid transparent;
      border-bottom: 44px solid transparent;
      border-right: 44px solid #fff;
    }
  }

  .close-modal {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 1rem;
    cursor: pointer;
    color: $text;
    z-index: 3;
    display: none;
  }
}

.touch-device {
  .close-modal {
    display: block;
  }
}

.modal-w {
  .modal-content {
    text-align: center;
    h3 {
      text-align: center;
      span {
        color: #31b0c1;
        display: inline-block;
        border-radius: 33px;
        padding: 5px 13px;
        font-weight: bold;
        border: 2px solid #31b0c1;
      }
    }

    p {
      color: #000;
      display: inline-block;
      padding: 1.5em 0;
      text-align: center;
    }
  }
  .modal-footer {
    text-align: center;
    position: relative;
    padding-top: 1.5em;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 1px;
      width: 100%;
      background-color: #dadada;
    }
    a {
      text-align: center;
      padding: 0.5em 0;
      text-decoration: none;
      color: $text;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 10px;
        width: 25px;
        height: auto;
      }
    }
  }
}
</style>
